module.exports = __webpack_public_path__ + "img/chadle.26be4914.svg";